// About.js
import React from 'react';
import './About.css';
import aboutImage from '../assets/images/about_image.png';
import SEO from '../SEO';

function About() {
    return (
        <React.Fragment>
            <SEO
                title="About JDS Hospitals | Compassionate Care Since 2008 | Visakhapatnam"
                description="Learn about JDS Hospitals, Visakhapatnam — a leading multispeciality hospital with expert doctors, advanced technology, and patient-first care since 2008."
                keywords="about JDS Hospitals, JDS Hospitals history, Visakhapatnam hospital about, multispeciality hospital Vizag"
                path="/About"
            />
            <section className="container-fluid" id="about-section">
                <div className='container py-5'>
                    <div className='about-title'>
                        <h1>About Us</h1>
                    </div>
                    <div className="row about-row">
                        {/* Image Section */}
                        <div className="col-12 col-md-5 col-lg-4 about-image">
                            <img src={aboutImage} alt="About JDS Hospitals" className="img-fluid" />
                        </div>

                        {/* Text Section */}
                        <div className="col-12 col-md-6 col-lg-6 about-info">
                            <p>
                                Welcome to JDS Hospitals, your trusted partner in managing your healthcare needs conveniently and efficiently. At JDS Hospitals, we understand the challenges individuals face when it comes to scheduling doctor appointments and managing their health records.
                            </p>
                            <p>
                                JDS Hospitals is committed to excellence in healthcare. We continuously strive to enhance our services, integrating the latest medical advancements to improve patient experience and deliver superior care. Whether you're booking your first appointment or managing ongoing care, JDS Hospitals is here to support you every step of the way.
                            </p>
                            <h4 className="about-vision-title">Our Vision</h4>
                            <p>
                                Our vision at JDS Hospitals is to create a seamless healthcare experience for every patient. We aim to bridge the gap between patients and healthcare providers, making it easier for you to access the care you need, when you need it.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default About;
